<template>
	<div class="declaration-detail">
		<template v-if="!isShowDetail">
			<el-form ref="form" :model="form" label-width="70px">
				<el-row :gutter="10">
					<!-- <el-col :span="5">
						<el-form-item label="" label-width="0px">
							<el-select v-model="form.projectId" clearable placeholder="请选择">
								<el-option v-for="item in projectOptions" :key="item.id" :label="item.projectName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="5">
						<el-form-item label="" label-width="0px"><el-input v-model="form.keyWords" placeholder="课题名称,负责人姓名,学校"></el-input></el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="学校">
							<el-select v-model="form.unitId" clearable placeholder="请选择">
								<el-option v-for="item in unitOptions" :key="item.id" :label="item.unitName" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="5">
						<el-form-item label="所属学段">
							<el-select v-model="form.learningType" clearable placeholder="请选择">
								<el-option v-for="item in learningTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item><el-button type="primary" @click="search">查询</el-button></el-form-item>
					</el-col>
				</el-row>
			</el-form>
			
			<el-table id="table" :data="declarationDetail" border style="width: 100%">
				<el-table-column type="index" label="序号" width="50" align="center"></el-table-column>
				<el-table-column prop="name" label="课题名称" width="180" align="center">
					<template v-slot="scope">
						<div style="color: deepskyblue;cursor: pointer;" @click="viewTopicDetail(scope.row)">{{scope.row.name}}</div>
					</template>
				</el-table-column>
				<el-table-column prop="oneEmceeName" label="负责人" width="180" align="center"></el-table-column>
				<el-table-column prop="createTime" label="申报时间">
					<template slot-scope="scope">
						{{ scope.row.createTime | getTime }}
					</template>
				</el-table-column>
				<el-table-column prop="unitName" label="工作单位" align="center"></el-table-column>
				<el-table-column prop="learningTypeName" label="所属学段" align="center"></el-table-column>
				<el-table-column prop="disciplineName" label="学科" align="center"></el-table-column>
				<!-- <el-table-column prop="projectTypeName" label="课题类别"></el-table-column> -->
				<el-table-column prop="expectedClosingTime" label="预结题时间" align="center">
					<template slot-scope="scope">
						{{ scope.row.expectedClosingTime | getTime }}
					</template>
				</el-table-column>
			</el-table>
			
			<el-pagination
				style="margin-top: 20px;text-align: center;"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="form.pageNumber"
				:page-sizes="[10, 20, 50]"
				:page-size="form.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
			></el-pagination>
			
			<div class="btn-wrap"><el-button type="success" @click="exportExcel">导出excel</el-button></div>
		</template>
		
		<TopicReviewDetail @goback="isShowDetail=false" :topicInfo="topicInfo" v-else/>
		
	</div>
</template>

<script>
import { getDeclarationDetail, getEduProjectLsit } from '@/api/after/projectApplication.js';
import { getUnitList } from '@/api/after/systemManagement.js';
import { TopicDeclarationDetail } from '@/api/after/schoolAudit.js';
import TopicReviewDetail from '../../components/TopicReviewDetail.vue'
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {
	components: {
		TopicReviewDetail
	},
	data() {
		return {
			form: {
				keyWords: '',
				pageNumber: 1,
				pageSize: 10,
				projectId: '',
				unitId: '',
				learningType: ''
			},
			projectOptions: [],
			projectData:{},
			unitOptions: [],
			learningTypeOptions: [
				{
					value: 0,
					label: '幼儿园'
				},
				{
					value: 1,
					label: '小学'
				},
				{
					value: 2,
					label: '初中'
				},
				{
					value: 3,
					label: '高中'
				},
				{
					value: 4,
					label: '高/中职'
				},
				{
					value: 5,
					label: '其他'
				}
			],
			declarationDetail: [],
			total: 0,
			topicInfo:{},
			isShowDetail:false
		};
	},
	async created() {
		let projectData=sessionStorage.getItem('projectData')
		if(projectData){
			this.projectData=JSON.parse(projectData)
			this.form.projectId = this.projectData.id;
		}else {
			this.$message({
				type: 'error',
				message: '没有项目！',
				onClose: () => {
					this.$router.go(-1);
				}
			});
		}
		this.getDeclarationDetail();
		this.getUnitList();
	},
	methods: {
		// 课题申报详情
		async TopicDeclarationDetail(id){
			const res = await TopicDeclarationDetail(id)
			if (res.code == 200) {
				console.log('详情',res);
				this.topicInfo = res.data
				// this.$nextTick(()=>{
				// 	// 数据请求成功之后渲染pdf
				// 	if (Object.keys(this.topicInfo).length) {
				// 		this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
				// 	}
				// })
			}else{
				this.$message.error(res.data)
			}
		},
		// 点击课题名称查看详情
		async viewTopicDetail(data){
			await this.TopicDeclarationDetail(data.id)
			this.isShowDetail = true
		},
		// 导出Excel列表
		exportExcel() {
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '申报明细.xlsx');
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		// 搜索
		search() {
			this.form.pageNumber = 1;
			this.getDeclarationDetail();
		},
		// 获取单位列表
		async getUnitList() {
			let params = {
				id: 0,
				name: '',
				pageNumber: 1,
				pageSize: 999,
				pageSorts: [
					{
						asc: true,
						column: ''
					}
				]
			};
			const res = await getUnitList(params);
			if (res.code == 200) {
				this.unitOptions = res.data.records;
			}
		},
		// 获取项目列表
		async getEduProjectLsit() {
			const res = await getEduProjectLsit();
			if (res.code == 200) {
				this.projectOptions = res.data;
			}
		},
		// 获取申报详情
		async getDeclarationDetail() {
			const res = await getDeclarationDetail(this.form);
			if (res.code == 200) {
				this.declarationDetail = res.data.records;
				this.total = res.data.total;
			}
		},
		handleSizeChange(val) {
			this.form.pageSize = val;
		},
		handleCurrentChange(val) {
			this.form.pageNumber = val;
		}
	}
};
</script>

<style scoped lang="scss">
.btn-wrap {
	margin-top: 20px;
}
</style>
